export const ORDER_STATUSES = [
  "PENDING",
  "CONFIRMED",
  "PREPARING",
  "OUT_FOR_DELIVERY",
  "DELIVERED",
  "CANCELLED",
  "DELIVERY_FAILED",
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

/**
 * Status transitions the Admin may apply (enforced by the backend).
 * DELIVERY_FAILED is set only by the assigned driver; from there the Admin decides:
 * re-confirm (the order becomes available to drivers again) or cancel.
 */
export const ORDER_TRANSITIONS: Record<OrderStatus, OrderStatus[]> = {
  PENDING: ["CONFIRMED", "CANCELLED"],
  CONFIRMED: ["OUT_FOR_DELIVERY", "CANCELLED"],
  // Retired step ("En préparation"): no order can enter it any more. Kept so that old data stays valid.
  PREPARING: ["OUT_FOR_DELIVERY", "CANCELLED"],
  OUT_FOR_DELIVERY: ["DELIVERED", "CANCELLED"],
  DELIVERED: [],
  CANCELLED: [],
  DELIVERY_FAILED: ["CONFIRMED", "CANCELLED"],
};

/** Statuses considered "current" (still in progress) for the customer. */
export const ACTIVE_ORDER_STATUSES: OrderStatus[] = ["PENDING", "CONFIRMED", "PREPARING", "OUT_FOR_DELIVERY", "DELIVERY_FAILED"];

/** Confirmed orders that drivers may accept (when no driver is assigned yet). */
export const DRIVER_AVAILABLE_STATUSES: OrderStatus[] = ["CONFIRMED", "PREPARING"];

export const PAYMENT_STATUSES = ["PENDING", "PAID", "FAILED", "CANCELLED"] as const;
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

/** Allowed COD payment status transitions (enforced by the backend). */
export const PAYMENT_TRANSITIONS: Record<PaymentStatus, PaymentStatus[]> = {
  PENDING: ["PAID", "FAILED", "CANCELLED"],
  FAILED: ["PAID", "PENDING", "CANCELLED"],
  PAID: ["PENDING"], // correction of a mistaken entry; requires a note
  CANCELLED: ["PENDING"],
};

export const PAYMENT_METHODS = ["CASH_ON_DELIVERY"] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const DISCOUNT_TYPES = ["PERCENTAGE", "FIXED"] as const;
export type DiscountType = (typeof DISCOUNT_TYPES)[number];

export const STAFF_PERMISSIONS = [
  "PRODUCTS",
  "CATEGORIES",
  "ORDERS",
  "CUSTOMERS",
  "COUPONS",
  "PAYMENTS",
  "DELIVERY",
  "STATS",
] as const;
export type StaffPermission = (typeof STAFF_PERMISSIONS)[number];

export const STAFF_ROLES = ["OWNER", "ADMIN", "DRIVER"] as const;
export type StaffRole = (typeof STAFF_ROLES)[number];

export const OTP_LENGTH = 4;
export const MAX_CART_QUANTITY = 50;
